/* eslint-disable */
import React from 'react';

export const Background = () => {
  return (
    <>
      <ul id="Workflow_Header_Comprehensive" className="workflow-menu-list">
        <li data-tab="General" className="selected">
          General
        </li>
        <li data-tab="Accounts">Accounts</li>
        <li data-tab="Income">Income</li>
        <li data-tab="Expenses">Expenses</li>
        <li data-tab="Advanced">Advanced</li>
      </ul>
      <div className="progress-bar">
        <div className="tracker" style={{ right: 'calc(80% + 32px)' }} />
      </div>
      <div className="module">
        <div id="Profile">
          <div id="Profile_PersonalInfo" className="Profile">
            <header>
              <h2>Personal Information</h2>
            </header>
            <div className="people">
              <ul className="people" id="Profile_PersonalInfo_People">
                <li className="principal model-bound">
                  <form className="adv-form">
                    <ul className="person horizontal-layout">
                      <li className="FirstName">
                        {/* eslint-disable-next-line */}
                        <label>First Name</label>
                        <input maxLength="50" name="FirstName" value="" type="text" />
                      </li>
                      <li className="LastName">
                        {/* eslint-disable-next-line */}
                        <label>Last Name</label>
                        <input maxLength="50" name="LastName" value="" type="text" />
                      </li>
                      <li className="YearOfBirth">
                        {/* eslint-disable-next-line */}
                        <label>Year of Birth</label>
                        <select
                          disabled
                          className="alight-select"
                          name="YearOfBirth"
                          defaultValue=""
                        >
                          <option value="" />
                        </select>
                      </li>
                      <li className="actions">
                        <button className="secondary remove">
                          <i className="far fa-trash-alt del" />
                          Remove
                        </button>
                      </li>
                    </ul>
                  </form>
                </li>
                <li className="partner model-bound">
                  <h3>Partner</h3>
                  <form className="adv-form">
                    <ul className="person horizontal-layout">
                      <li className="FirstName">
                        {/* eslint-disable-next-line */}
                        <label>First Name</label>
                        <input maxLength="50" name="FirstName" value="" type="text" />
                      </li>
                      <li className="LastName">
                        {/* eslint-disable-next-line */}
                        <label>Last Name</label>
                        <input maxLength="50" name="LastName" value="" type="text" />
                      </li>
                      <li className="YearOfBirth">
                        {/* eslint-disable-next-line */}
                        <label>Year of Birth</label>
                        <select
                          disabled
                          className="alight-select"
                          name="YearOfBirth"
                          defaultValue=""
                        >
                          <option value="" />
                        </select>
                      </li>
                      <li className="actions">
                        <button className="secondary remove">
                          <i className="far fa-trash-alt del" />
                        </button>
                      </li>
                    </ul>
                  </form>
                </li>
                <li className="children">
                  <h3>
                    Children
                    <button className="add secondary">
                      <i className="fa fa-plus" />
                      Add Child
                    </button>
                  </h3>
                  <ul>
                    <li className="child model-bound">
                      <form className="adv-form">
                        <ul className="person horizontal-layout">
                          <li className="FirstName">
                            {/* eslint-disable-next-line */}
                            <label>First Name</label>
                            <input maxLength="50" name="FirstName" value="" type="text" />
                          </li>
                          <li className="LastName">
                            {/* eslint-disable-next-line */}
                            <label>Last Name</label>
                            <input maxLength="50" name="LastName" type="text" />
                          </li>
                          <li className="YearOfBirth">
                            {/* eslint-disable-next-line */}
                            <label>Year of Birth</label>
                            <select
                              disabled
                              className="alight-select"
                              name="YearOfBirth"
                              defaultValue=""
                            >
                              <option value="" />
                            </select>
                          </li>
                          <li className="actions">
                            <button className="secondary remove">
                              <i className="far fa-trash-alt del" />
                            </button>
                          </li>
                        </ul>
                      </form>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="nav-actions">
              <button className="green rhs save">Save &amp; Next</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
